/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Card 6: Your Identity Statements with Archetype Lens.
 *
 * The 5 statements come verbatim from the user's IPSAT 1.0 input (passed
 * in as `statements`). The archetype-lens line is AI-generated per
 * Steve's Prompt 2 (one sentence per statement). Until Phase C lands,
 * only the verbatim statements render — the lens lines show a "generating"
 * placeholder.
 */
interface StatementWithLens {
  statement_type: string;
  statement_text: string;
  archetype_lens?: string;
}

@Component({
  selector: 'app-identity-statements-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './identity-statements-modal.component.html',
})
export class IdentityStatementsModalComponent {
  @Input() statements: StatementWithLens[] = [];

  constructor(public bsModalRef: BsModalRef) {}

  close(): void {
    this.bsModalRef.hide();
  }
}
